// import app from '../../../src/App.vue'
import Vue from "vue";
import Toast from "vue-easy-toast";
import httpService from "../../components/service";

Vue.use(Toast);

export const items = {
    namespaced: true,
    state: {
        items: {},
        relatedModules: {},
        relatedProducts: {},
        relatedItems: {},
        imgEdit: false,
        editCampaignObj: {},
        campaignList: {},
        editStandDesign: {},
        editZone: {},
        editBrand: {},
        editComponentType: null,
        ticketStrips: {},
        editDisplay: {},
        relatedTicketsStrip: [],
        imgObject: [],
        elementItems: {}
    },
    getters: {
        getAllItems: state => {
            return state.items;
        },
        getItems: (state, getters) => length => {
            return Object.entries(state.items).map(entry => entry[1]);
        },
        getItemsLength: state => {
            let ret = new Map(Object.entries(state.items));
            return ret.size;
        },
        getDetails: state => id => {
            return state.items[id];
        },
        getRelatedModules: state => {
            return state.relatedModules;
        },
        getRelatedProducts: state => {
            return state.relatedProducts;
        },
        getRelModulesLength: state => {
            let ret = new Map(Object.entries(state.relatedModules));
            return ret.size;
        },
        getRelProductsLength: state => {
            let ret = new Map(Object.entries(state.relatedProducts));
            return ret.size;
        },
        getRelatedItems: (state, getters) => {
            return state.relatedItems;
        },
        getConfig: (state, getters) => id => {
            return state.items[id].config;
        },
        getImgEditor: state => {
            return state.imgEdit;
        },
        getEditCampaignObj(state) {
            return state.editCampaignObj;
        },
        getCampaignList(state) {
            return state.campaignList;
        },
        getStandDesign(state) {
            return state.editStandDesign;
        },
        getZone(state) {
            return state.editZone;
        },
        getBrand(state) {
            return state.editBrand;
        },
        getComponentType(state) {
            return state.editComponentType;
        },
        getEditDisplay(state) {
            return state.editDisplay;
        },
        findRelatedTicketsStrip(state) {
            return state.relatedTicketsStrip;
        },
        getRelatedTicketsStrip(state) {
            return state.relatedTicketsStrip;
        },
        getImgObject(state) {
            return state.imgObject;
        },
        getElementItem(state) {
            return state.elementItems;
        }
    },
    mutations: {
        POPULATE_ITEMS(state, data) {
            state.items = data;
        },
        ENRICH_MODULE(state, data) {
            state.items[data.id] = data;
        },
        ENRICH_RELATED_PRODUCT(state, data) {
            state.relatedProducts = data;
        },
        ENRICH_RELATED_MODULE(state, related) {
            state.relatedModules = related;
        },
        ENRICH_RELATED_ITEMS(state, data) {
            state.relatedItems = data;
        },
        SET_MODULE_CONFIG(state, data) {
            if (typeof state.items[data.id] === "undefined") {
                state.items[data.id] = {};
            }
            state.items[data.id].config = data.config;
        },
        SET_IMAGE_EDITOR(state, data) {
            state.imgEdit = data.imgEdit;
        },
        SET_EDIT_CAMPAIGN_OBJ(state, editCampaignObj) {
            state.editCampaignObj = editCampaignObj;
        },
        SET_CAMPAIGN_LIST(state, campaignList) {
            state.campaignList = campaignList;
        },
        SET_EDIT_STAND(state, editStandDesign) {
            state.editStandDesign = editStandDesign;
        },
        SET_EDIT_ZONE(state, editZone) {
            state.editZone = editZone;
        },
        SET_EDIT_BRAND(state, editBrand) {
            state.editBrand = editBrand;
        },
        SET_EDIT_COMPONENT(state, editComponentType) {
            state.editComponentType = editComponentType;
        },
        SET_EDIT_DISPLAY(state, editDisplay) {
            state.editDisplay = editDisplay;
        },
        FIND_RELATED_TICKET(state, tickets) {
            state.relatedTicketsStrip = tickets;
        },
        ENRICH_RELATED_TICKET_STRIPS(state, ticketStrips) {
            state.ticketStrips = ticketStrips;
        },
        SET_IMG_OBJECT(state, imgObject) {
            state.imgObject = imgObject;
        },
        SET_ELEMENT_ITEMS(state, elementItems) {
            state.elementItems = elementItems;
        }
    },
    actions: {
        populate: context => {
            return new Promise((resolve, reject) => {
                httpService.get("/components").then(data => {
                    let items = {};
                    items = data.data;
                    context.commit("POPULATE_ITEMS", items);
                    resolve();
                });
            });
        },
        getDetails: (context, data) => {
            return new Promise((resolve, reject) => {
                // missing "typeof" here?
                if (data.id !== "undefined") {
                    httpService.get("/components/" + data.id).then(response => {
                        if (response.code === 400) {
                        } else if (response.code === 404) {
                            context.commit("ENRICH_MODULE", response);
                            resolve(response);
                        } else {
                            context.commit("ENRICH_MODULE", response.data[0]);
                            resolve(response.data[0]);
                        }
                    });
                }
            });
        },
        async getComponent({ commit }, id) {
            const response = await httpService.get("/components/" + id);
            if (response.code) throw response;
            commit("ENRICH_MODULE", response.data[0]);
            return response.data[0];
        },
        getRelatedProducts: (context, data) => {
            return new Promise((resolve, reject) => {
                if (data.id !== "undefined") {
                    httpService.get("/components/" + data.id + "/related-products").then(response => {
                        let relatedProducts = {};
                        for (let products of response.data) {
                            relatedProducts[products.id] = products;
                        }
                        context.commit("ENRICH_RELATED_PRODUCT", response.data);
                        resolve(response);
                    });
                }
            });
        },
        findRelatedTicketsStrip(context, data) {
            return httpService.get("/components/" + data.id + "/related-ticket-strip").then(response => {
                context.commit("FIND_RELATED_TICKET", response.data);
                return response;
            });
        },
        getRelatedModules: (context, data) => {
            return new Promise((resolve, reject) => {
                if (data.id !== "undefined") {
                    httpService.get("/components/" + data.id + "/related-modules").then(response => {
                        let relatedModules = {};
                        for (let relatedModule of response.data) {
                            relatedModules[relatedModule.id] = relatedModule;
                        }
                        context.commit("ENRICH_RELATED_MODULE", response.data);
                        resolve(response.data);
                    });
                }
            });
        },
        getRelatedItems: (context, data) => {
            return new Promise((resolve, reject) => {
                if (data.id !== "undefined") {
                    httpService.get("/components/related/" + data.id + "?bycategory=true", JSON.stringify({})).then(response => {
                        let allRelatedItems = {};
                        for (let items of response.data) {
                            allRelatedItems[items.id] = items;
                        }
                        context.commit("ENRICH_RELATED_ITEMS", allRelatedItems);
                        resolve(allRelatedItems);
                    });
                }
            });
        },
        getTicketStrips: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService.get("/components?limit=20&categoryName=ticket-strip&type=4").then(response => {
                    let allRelatedItems = {};
                    allRelatedItems = response.data;
                    context.commit("ENRICH_RELATED_TICKET_STRIPS", allRelatedItems);
                    resolve();
                });
            });
        },
        setModuleConfig: (context, data) => {
            return new Promise((resolve, reject) => {
                let apiUrl = "/components/" + data.id + "/config";
                httpService.put(apiUrl, JSON.stringify({ content: data.config })).then(function(datas) {
                    Vue.toast("ENREGISTREMENT REUSSI", {
                        id: "my-toast",
                        className: ["my-toast", "toast-warning", "flexContainer"],
                        horizontalPosition: "right",
                        verticalPosition: "bottom",
                        mode: "queue"
                    });
                    resolve(datas);
                });
            });
        },
        getModuleConfig: (context, data) => {
            // TODO: refactor this outside of vue store
            return new Promise((resolve, reject) => {
                let apiUrl = "/components/" + data.id + "/config";
                httpService
                    .get(apiUrl)
                    .then(function(datas) {
                        return datas;
                    })
                    .then(response => {
                        context.commit("SET_MODULE_CONFIG", response.data[0]);
                        resolve(response.data[0]);
                    });
            });
        },
        setEditCampaignObj(context, editCampaignObj) {
            context.commit("SET_EDIT_CAMPAIGN_OBJ", editCampaignObj);
        },
        setCampaignList(context, campaignList) {
            context.commit("SET_CAMPAIGN_LIST", campaignList);
        },
        setStandDesign(context, editStandDesign) {
            context.commit("SET_EDIT_STAND", editStandDesign);
        },
        setZone(context, editZone) {
            context.commit("SET_EDIT_ZONE", editZone);
        },
        setBrand(context, editBrand) {
            context.commit("SET_EDIT_BRAND", editBrand);
        },
        setComponentType(context, editComponentType) {
            context.commit("SET_EDIT_COMPONENT", editComponentType);
        },
        setEditDisplay(context, editDisplay) {
            context.commit("SET_EDIT_DISPLAY", editDisplay);
        },
        setImgObject(context, imgObject) {
            context.commit("SET_IMG_OBJECT", imgObject);
        },
        async getElementItems(context, data) {
            // TODO: refactor this outside of vue store
            let api = "/components";
            let hasParams = false;
            let { carcass, cluster, plano, type } = data;

            if (carcass === 1 || carcass === "1") {
                api += !hasParams ? "?" : "";
                api += "elementCarcass=" + carcass;
                hasParams = true;
            }

            if (cluster === 1 || cluster === "1") {
                api += !hasParams ? "?" : "&";
                api += "elementCluster=" + cluster;
                hasParams = true;
            }

            if (plano === 1 || plano === "1") {
                api += !hasParams ? "?" : "&";
                api += "elementPlano=" + plano;
                hasParams = true;
            }

            if (type) {
                api += !hasParams ? "?" : "&";
                api += "type=" + type;
            }

            const resp = (await httpService.get(api)).data;
            context.commit("SET_ELEMENT_ITEMS", resp);
            return resp;
        },

        async removeBrandImg(context, type) {
            if (context.state.editBrand.id) {
                const res = await httpService.delete("/admin/brands/" + context.state.editBrand.id + "/remove-images?" + type + "=1");
                if (res.code) throw new Error(res.message);
                context.commit("SET_EDIT_STAND", res);
                return res;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/items/items.js